import { render, staticRenderFns } from "./v-empty.vue?vue&type=template&id=f2768ffc&scoped=true"
import script from "./v-empty.vue?vue&type=script&lang=js"
export * from "./v-empty.vue?vue&type=script&lang=js"
import style0 from "./v-empty.vue?vue&type=style&index=0&id=f2768ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2768ffc",
  null
  
)

export default component.exports